import DailyTimeRangeInput from './DailyTimeRangeInput';

interface Props {
  pauseType: string;
  DailyTimeRange: string;
  WeeklyTimeRange: string;
  MonthlyTimeRange: string;
  setDailyTimeRange: (v: string) => void;
  setWeeklyTimeRange: (v: string) => void;
  setMonthlyTimeRange: (v: string) => void;
}

export default function PauseTimeSelector({
  pauseType,
  DailyTimeRange,
  WeeklyTimeRange,
  MonthlyTimeRange,
  setDailyTimeRange,
  setWeeklyTimeRange,
  setMonthlyTimeRange,
}: Props) {
  if (pauseType === 'daily') {
    return <DailyTimeRangeInput value={DailyTimeRange} onChange={setDailyTimeRange} />;
  }
  if (pauseType === 'weekly') {
    return <DailyTimeRangeInput value={WeeklyTimeRange} onChange={setWeeklyTimeRange} />;
  }
  if (pauseType === 'monthly') {
    return <DailyTimeRangeInput value={MonthlyTimeRange} onChange={setMonthlyTimeRange} />;
  }
  return null;
}
